import { css } from "@emotion/react";
import ListBackground from "assets/temporary/images/list_bg_2.jpg";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";
export const BankStyle = {
  modalContainer: () => css`
    .ant-modal-content {
      padding: 0px !important;
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
      border-radius: 12px;
      overflow: hidden;
      background: ${theme.colors.white};
      min-height: 350px;
    }
  `,
  container: () => css``,
  header: () => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    flex-direction: row;
    padding-left: 16px;
    padding-right: 16px;
    background-image: url(${ListBackground});
    backface-visibility: initial;
    height: 75px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    span {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      color: ${theme.colors.white};
    }
  `,
  buttonClose: () => css`
    width: 24px;
    height: 24px;
    border: 0px;
    background-color: transparent;

    img {
      width: 24px;
      height: 24px;
    }
  `,
  content: () => css`
    padding-bottom: 32px;
  `,
  create_box: () => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    gap: 10px;
    height: 84px;
    background: #f5f5f5;
    border-radius: 4px;
    margin: 32px 32px 16px 32px;
    cursor: pointer;
    div:nth-of-type(1) {
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-weight: 700;
        font-size: 13px;
        line-height: 18px;
        color: ${theme.colors.darkGreen};
        vertical-align: middle;
      }
    }
  `,
  bankCard: () => css`
    width: 52px;
    height: 52px;

    img {
      width: 100%;
      height: 100%;
    }
  `,
  center: () => css`
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      color: ${theme.colors.text.black};
    }
  `,
  listBank: () => css`
    padding: 0 32px;
  `,
  labelList: () => css`
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    color: ${theme.colors.text.black};
  `,
  itemBank: () => css`
    position: relative;
    height: 100px;

    ${media.sm} {
      height: 72px;
    }
  `,
  itemBg: () => css`
    width: calc(100%);
    position: absolute;
    top: 0;
    z-index: 1;

    ${media.sm} {
      height: 100%;
    }
  `,
  itemBankInfo: () => css`
    width: calc(100%);
    position: absolute;
    top: 0;
    z-index: 2;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${theme.colors.white};
    padding: 16px;

    ${media.sm} {
      padding: 8px;
    }

    div:nth-of-type(1) {
      flex: 1;
      display: flex;
      flex-direction: column;

      span:nth-of-type(1) {
        text-transform: uppercase;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      span:nth-of-type(2) {
        text-transform: uppercase;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }

    div:nth-of-type(2) {
      flex: 1;
      display: flex;
      justify-content: flex-end;
    }
  `,
  // bank mapping
  bank: () => css`
    height: 44px;
    border: 1px solid ${theme.borders.secondary};
    background: ${theme.colors.black100};
    border-radius: 8px;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: ${theme.colors.lightText};
    font-weight: 400;
    cursor: pointer;
    margin-bottom: 12px;

    &:hover {
      border-color: ${theme.borders.primary};
    }

    svg path {
      stroke: ${theme.colors.lightText};
    }
  `,
  optCode: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 1px solid ${theme.borders.secondary};
    background: ${theme.colors.black100};
    border-radius: 6px;
    overflow: hidden;

    &:focus-within {
      border-color: ${theme.borders.primary};
    }

    input {
      width: 100%;
      min-width: 0;
      height: 44px;
      border: 0;
      padding: 0 8px;
      outline: none !important;
      font-size: 14px;
      color: ${theme.colors.lightText};
      background: transparent;
      font-weight: 400;
      &:disabled {
        background-color: transparent;
        cursor: no-drop;
      }
      ::placeholder {
        font-size: 14px;
        color: ${theme.colors.lightText};
        opacity: 0.6;
      }
    }

    button {
      border: 0;
      background: ${theme.colors.gradient[1]};
      height: 36px;
      padding: 0 8px;
      margin-right: 4px;
      white-space: nowrap;
      border-radius: 5px;
      color: ${theme.colors.text.buttonActive};
      font-weight: 600;
      cursor: pointer;
      min-width: 70px;

      &:disabled {
        background: ${theme.palette.accent.softTint};
        border: 1px solid ${theme.borders.secondary};
        color: ${theme.palette.text.muted};
        cursor: no-drop;
      }

      span {
        line-height: unset !important;
        color: inherit;
      }
    }
  `,
};

export const BankMappingStyle = {
  modalContainer: () => css`
    .ant-modal-content {
      background: ${theme.colors.black100};
      border: 1px solid ${theme.borders.primary};
      color: ${theme.colors.lightText};
    }
  `,
  header: () => css`
    background: ${theme.colors.gradient[1]};

    span {
      color: ${theme.colors.text.buttonActive};
    }

    button {
      padding: 0;
      box-shadow: none;
      background: transparent;

      &:hover {
        background: transparent !important;
      }

      img {
        filter: brightness(0);
      }
    }
  `,
  currency: () => css`
    margin-bottom: 12px;
  `,
  content: () => css`
    padding: 32px;

    .ant-input:disabled {
      background: ${theme.palette.surface.elevated};
      color: ${theme.colors.lightText};
      -webkit-text-fill-color: ${theme.colors.lightText};
      border-color: ${theme.borders.secondary};
      opacity: 1;
    }

    .notes {
      font-style: italic;
      margin-bottom: 12px;
      font-size: 12px;
      color: #ff3700;
    }
  `,
  button: () => css`
    width: 100%;
    height: 44px;
    border-radius: 8px;
    background: ${theme.colors.gradient[1]};
    border: 1px solid ${theme.borders.primary};
    margin-top: 40px;
    color: ${theme.colors.text.buttonActive};
    font-weight: 600;
    transition: 0.15s all;

    &:not(:disabled):hover,
    &:not(:disabled):focus-visible {
      background: ${theme.colors.gradient[1]};
      border-color: ${theme.borders.primary};
      color: ${theme.colors.text.buttonActive};
      box-shadow: 0 0 8px ${theme.palette.accent.glow};
    }

    &:disabled,
    &:disabled:hover {
      background: ${theme.palette.accent.softTint};
      border-color: ${theme.borders.secondary};
      color: ${theme.palette.text.muted};
      cursor: not-allowed;
    }
  `,
};

export const ModalSelectBankStyle = {
  index: () => css`
    width: 480px !important;

    .ant-modal-content {
      padding: 0;
      background-color: ${theme.colors.black100};
      color: ${theme.colors.lightText};
      border: 1px solid ${theme.borders.primary};
      border-radius: 10px;
    }
    button.ant-modal-close {
      color: ${theme.colors.lightText};
      svg {
        width: 24px;
        height: 24px;
      }
    }
  `,
  selectBank: () => css`
    padding: 12px;
    height: 44px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${theme.colors.black100};
    color: ${theme.colors.lightText};
    border-bottom: 1px solid ${theme.borders.secondary};
    cursor: pointer;

    &:hover {
      background: ${theme.palette.accent.tint};
    }
  `,
};
